import React, { useState } from 'react'
import FormLayout from '../components/form/layout/FormLayout'
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import TextInput from '../components/form/text-input/TextInput';
import { useAppDispatch, useAppSelector } from '../hooks/store.hook';
import { setErrorMessages } from '../store/slices/error.slice';
import { sendForgetPasswordEmail } from '../utilities/api';
import { setSuccessMessage } from '../store/slices/success.slice';
import AuthFormLayout from '../components/form/auth-layout/AuthFormLayout';


const schema = yup.object({
    email: yup.string().email().required("Email is required"),
}).required();


export default function ForgetPasswordSendEmail() {

    const dispatch = useAppDispatch()

    const [isLoading, setLoading] = useState(false)
    //form part
    const { control, handleSubmit, setValue, formState: { errors, isDirty, isValid }, reset } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
        defaultValues: {
            email: "",
        }
    });

    const onSubmit = async (data: any) => {
        setLoading(true)
        try {
            await sendForgetPasswordEmail(data)
            reset()
            dispatch(setSuccessMessage("Forget Password Email sent successfully"))
        } catch (error) {
            dispatch(setErrorMessages(error))
        } finally {
            setLoading(false)
        }
    }

    return (
        <AuthFormLayout
            title='Forget Password'
            subTitle="Enter your email and we' ll send you a password reset link."
            onSubmit={handleSubmit(onSubmit)}
            button={{
                isDirty: true,
                loading: isLoading,
                isValid,
                text: "Submit"
            }}
        >
            <Grid
                container
                columnSpacing={{ xs: 0, md: 4 }}
                rowSpacing={{ md: 4, xs: 2 }}
                mb={{ xs: 2, md: 4 }}
            >
                <Grid item xs={12} >
                    <TextInput
                        control={control}
                        name={"email"}
                        error={errors.email?.message}
                        label={"Email"}
                        placeholder="Email"
                    />
                </Grid>
            </Grid>
        </AuthFormLayout>
    )
}
